<template>
  <div class="content" style="padding-top: 20px">
    <div class="bg">
      <a-form ref="formRef" name="advanced_search" class="ant-advanced-search-form" :model="formState"
        @finish="onFinish">
        <a-row :gutter="24">
          <a-col :span="5">
            <h1 class="jzlb">告警列表</h1>
          </a-col>
          <a-col :span="4">
            <a-form-item label="基站ID">
              <a-input v-model:value="formState.stationNo" placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="告警类型">
              <a-select v-model:value="formState.warningType" style="background-color: transparent">

                <a-select-option value="SYSTEM_FALT">系统故障</a-select-option>
                <a-select-option value="SYSTEM_WARNING">系统告警</a-select-option>
                <a-select-option value="BATTERY_WARNING">电池告警</a-select-option>
                <a-select-option value="POWER_WARNING">电源告警</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="选择日期">
              <a-range-picker v-model:value="formState.riqi" show-time @ok="onOk13" format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss" />
            </a-form-item>
          </a-col>

          <a-col :span="2">
            <a-button type="primary" html-type="submit" @click="getData(1, 10)">搜索
            </a-button>
          </a-col>
          <a-col :span="5">
            <a-button type="primary" html-type="submit">全部</a-button>
            <a-button style="margin: 0 8px" @click="chulicx('RESOLVED')">已处理</a-button>
            <a-button @click="chulicx('WAITING')">未处理</a-button>
            <a-button style="margin: 0 8px">导出</a-button>
          </a-col>
        </a-row>
      </a-form>


      <a-table :columns="columns" :data-source="data" style="background-color: transparent !important; color: #fff"
        :pagination="false">
        <template #headerCell="{ column }">
          <template v-if="column.key === 'name'">
            <span>
              {{ column.name }}
            </span>
          </template>
        </template>

        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'name'">
            {{ record.name }}
          </template>

          <template v-else-if="column.key === 'action'">
            <span>
              <a v-if="record.processStatusText === '未处理'" @click="chuli(record.id)"> {{ record.processStatusText }}</a>
              <span style="color: #1890ff" v-else-if="record.processStatusText !== '未处理'">
                {{ record.processStatusText }}</span>
            </span>
          </template>
        </template>
      </a-table>
      <a-pagination :total="pagination.total" :pageSize="pagination.pageSize" responsive :current="pagination.current"
        :position="[bottomRight]" @change="pageChanged" />
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import http from "@/api/http";
import { defineComponent, ref, onMounted } from "vue";

const columns = [
  {
    title: "时间",
    dataIndex: "createdAtText",
    key: "createdAtText",
  },
  {
    title: "电池包编号",
    dataIndex: "batteryPackageNo",
    key: "batteryPackageNo",
  },
  {
    title: "基站ID",
    dataIndex: "stationNo",
    key: "stationNo",
  },
  {
    title: "告警类型",
    key: "warningTypeText",
    dataIndex: "warningTypeText",
  },
  {
    title: "告警情况",
    dataIndex: "warningContent",
    key: "warningContent",
  },
  {
    title: "操作",
    key: "action",
  },
];
let data = ref([]);

export default defineComponent({
  name: "GaoJing",
  components: {},
  props: {},
  setup() {
    const expand = ref(true);
    const formRef = ref();
    const formState = ref({
      stationNo: null,
      warningType: null,
      createdAtRange: null,
      riqi: null,
      processStatus: null,

    });

    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const onOk13 = (value) => {
      // clsz.value.peak1DatetimeStart = moment(clsz.value.peak1DatetimeStart).format('YYYY-MM-DD HH:mm:ss')

      console.log('onOk2: ', formState.value.createdAtRange);
      console.log('onOk: ', value);
    };
    const onFinish = (values) => {
      console.log("Received values of form: ", values);
      console.log("formState: ", formState);
    };
    const getData = (page, pageSize) => {
      if (formState.value.riqi !== null) {
        formState.value.createdAtRange = formState.value.riqi[0] + ',' + formState.value.riqi[1]
      }
      http.get("/base_station_warning?pageNum=" + page + "&pageSize=" + pageSize, { params: formState.value }).then(res => {

        if (res.code == 1) {
          data.value = res.data.records;

          pagination.value.total = res.data.total;
          pagination.value.pageSize = res.data.size;
          pagination.value.current = res.data.current;
        }
      });

    };


    const chulicx = (e) => {
      formState.value.processStatus = e

      getData(pagination.value.current, pagination.value.pageSize);

    };
    const chuli = (e) => {
      http.put("/base_station_warning/" + e + "/warning_status").then(() => {
        message.success('处理成功');
      });

    };
    const pageChanged = (page, pageSize) => {
      getData(page, pageSize);
      // if (sou.value == 0) {
      //   getData(page, pageSize);
      // } else {
      //   search()
      // }

    }
    onMounted(() => {
      //组件挂载时的生命周期执行的方法

      getData(pagination.value.current, pagination.value.pageSize);
    });
    return {
      chuli, chulicx, onOk13,
      getData,
      formRef,
      formState,
      expand,
      onFinish,
      value1: ref("请选择"),
      data,
      columns,
      pagination,
      pageChanged
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
.content {
  padding: 0 0px;
  background: url("@/assets/bg22.png");
  background-size: 100% 100%;

}

.ant-picker {
  background-color: #133964 !important;
  color: #fff !important;
  border: 1px #042954 solid !important;
}

.ant-input {
  background-color: #133964 !important;
  color: #fff !important;
  border: 1px #042954 solid !important;
}

.ant-select-selector {
  background-color: #133964 !important;
  color: #fff !important;
  border: 1px #042954 solid !important;
}

.ant-select {
  background-color: #133964 !important;
  color: #fff !important;
  border: 1px #042954 solid !important;
}

.bg {
  background-color: rgb(3, 28, 55, 0.8);
  padding: 20px 30px;
}

.ant-pagination {
  text-align: right;
  padding-top: 20px !important;
}

.jzlb {
  color: #fff;
  font-size: 14px;
  background: url("@/assets/biaoti.png") no-repeat;
  padding-left: 30px;
  font-weight: bold;
}

.ant-table {
  background-color: transparent !important;
}

.ant-table a {
  color: #ffff00;
}

.ant-form-item-label>label {
  color: #fff !important;
}
</style>
